export default __webpack_public_path__ + "static/media/clock.d6c588c3.svg";